import { jsx as s } from "react/jsx-runtime";
import '../../assets/Overlay.css';const i = "_overlay_fuhtc_1", r = "_visible_fuhtc_16", e = {
  overlay: i,
  visible: r
}, a = ({ isOpen: l, onClose: o }) => /* @__PURE__ */ s(
  "div",
  {
    className: `${e.overlay} ${l && e.visible} iOSPWA-overlay`,
    "aria-label": "Close",
    role: "button",
    onClick: o
  }
);
export {
  a as Overlay
};
